import { forwardRef } from 'react';
import { X, Search } from 'lucide-react';
import { SIDEBAR_WIDTH } from '../../../constants/layout';
import { Dataset } from '../../../types';
import { SidebarDatasetSection } from './SidebarDatasetSection';

interface SidebarOverlayPanelProps {
  datasets: Dataset[];
  selectedDatasetId?: string;
  isLoading: boolean;
  isLoadingMore: boolean;
  hasMoreDatasets: boolean;
  searchQuery: string;
  onClose: () => void;
  onOpenSearch: () => void;
  onLoadMore: () => void;
}

export const SidebarOverlayPanel = forwardRef<HTMLDivElement, SidebarOverlayPanelProps>(({
  datasets,
  selectedDatasetId,
  isLoading,
  isLoadingMore,
  hasMoreDatasets,
  searchQuery,
  onClose,
  onOpenSearch,
  onLoadMore,
}, ref) => {
  return (
    <div
      ref={ref}
      className="fixed z-50 flex flex-col bg-white rounded-xl border border-neutral-200 shadow-popover"
      style={{
        top: '80px',
        left: SIDEBAR_WIDTH.collapsed + 8,
        width: '280px',
        maxHeight: 'calc(100vh - 160px)',
        animation: 'sidebarOverlayIn 150ms ease-out',
      }}
    >
      <div className="flex items-center justify-between flex-shrink-0 px-4 py-3 border-b border-neutral-100">
        <h3 className="text-sm font-semibold text-neutral-800">Datasets</h3>
        <button
          onClick={onClose}
          className="p-1 rounded-md text-neutral-500 hover:bg-neutral-100 transition"
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      <div className="px-4 py-3">
        <button
          onClick={onOpenSearch}
          className="w-full flex items-center gap-2 rounded-lg py-2 px-3 text-13 bg-neutral-100 border border-neutral-200 text-neutral-500 hover:bg-white transition"
        >
          <Search className="w-3.5 h-3.5" />
          <span className="flex-1 text-left">Search...</span>
        </button>
      </div>

      <div className="flex-1 overflow-y-auto px-3 pb-3 scrollbar-hide">
        <SidebarDatasetSection
          datasets={datasets}
          selectedDatasetId={selectedDatasetId}
          isExpanded={true}
          isLoading={isLoading}
          isLoadingMore={isLoadingMore}
          hasMoreDatasets={hasMoreDatasets}
          searchQuery={searchQuery}
          onToggleSection={() => {}}
          onLoadMore={onLoadMore}
        />
      </div>
    </div>
  );
});

SidebarOverlayPanel.displayName = 'SidebarOverlayPanel';
